module.exports = __webpack_public_path__ + "3bb3bf5878b6e528514c0eef344c50e4.MP3";